import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

interface AdminRouteProps {
  children?: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("[ADMIN-ROUTE] Verificando permisos de administrador...");
    
    const checkAdmin = async () => {
      try {
        // Verificar si el usuario está autenticado
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("[ADMIN-ROUTE] Error al obtener sesión:", error);
          setIsAdmin(false);
          setLoading(false);
          return;
        }
        
        if (!data.session) {
          console.log("[ADMIN-ROUTE] No hay sesión activa");
          setIsAdmin(false);
          setLoading(false);
          return;
        }
        
        console.log("[ADMIN-ROUTE] Usuario autenticado:", data.session.user.email);
        
        // MÉTODO SIMPLIFICADO:
        // Si el usuario es n.guerravillalobos@gmail.com, permitir acceso
        if (data.session.user.email === 'n.guerravillalobos@gmail.com') {
          console.log("[ADMIN-ROUTE] Acceso concedido por email");
          setIsAdmin(true);
          setLoading(false);
          return;
        }
        
        // Verificar si el usuario tiene la marca de administrador en el almacenamiento local
        const adminFlag = localStorage.getItem('isAdmin');
        
        if (adminFlag === 'true') {
          console.log("[ADMIN-ROUTE] Acceso concedido por localStorage");
          setIsAdmin(true);
          setLoading(false);
          return;
        }
        
        // Si ninguna de las condiciones anteriores se cumple, no es admin
        console.log("[ADMIN-ROUTE] Acceso denegado - No es administrador");
        setIsAdmin(false);
      } catch (error) {
        console.error('[ADMIN-ROUTE] Error al verificar el estado de administrador:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkAdmin();
  }, []);

  if (loading) {
    // Mostrar un indicador de carga mientras se verifica el estado
    return (
      <div className="min-h-screen bg-gray-950 flex flex-col justify-center items-center">
        <div className="w-16 h-16 border-4 border-t-purple-500 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400">Verificando credenciales...</p>
      </div>
    );
  }

  // Redirigir a la página de inicio de sesión si no es administrador
  if (!isAdmin) {
    console.log("[ADMIN-ROUTE] Redirigiendo a /admin");
    return <Navigate to="/admin" replace />;
  }

  // Renderizar los componentes hijos si es administrador
  console.log("[ADMIN-ROUTE] Renderizando contenido de administrador");
  return children ? <>{children}</> : <Outlet />;
}

export default AdminRoute; 